import { getDepositorWiresApi } from '@/api/v1/depositor/getDepositorWiresApi';
import { prepareSearchNameListApiParams } from '@/helpers/apiHelpers/requestHelpers';
import { prepareResponse, throwResponseError } from '@/helpers/apiHelpers/responseHelpers';
import { ApiParams } from '@/api/helpers/apiHelpers';

export const loadDepositorWires = async (queryParams: ApiParams) => {
  const apiParams = prepareSearchNameListApiParams(queryParams);

  try {
    const response = await getDepositorWiresApi(apiParams);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};
